import styled,{css} from 'styled-components';
import Colors from 'constants/Colors';
import { FontWeight } from 'components/Text';
import { darken } from 'polished';

const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
  color: ${color};
  background-color: ${bg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${bgFocus};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${bgActive};
  }
   @media (max-width: 768px) {
  }
  ${args.length >= 1 ? args.join('\n') : ''}
  `;
}

const primaryMixin = generateStyle(Colors.WHITE, Colors.SECONDARY, darken(0.1, Colors.SECONDARY), darken(0.2, Colors.SECONDARY));

export const Heading = styled.h2`
  color: ${Colors.GRAY[6]};
  padding-left: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 20px;
`;


export const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ButtonContent = styled.div`
    display:flex;
    flex-direction:auto;
    background-color:FFF;  
    width: auto;

    button{

        padding: 0.75rem 3.75rem;

        @media(max-width: 1470px) {
          padding: 0.45rem 0.8rem;
        }

        @media(max-width: 760px) {
          padding: 0.15rem 0.2rem;
        }

        @media(max-width: 600px) {
          padding: 0.01rem 0.01rem;
          font-size:14px;
          flex-wrap: wrap;
          white-space: wrap;
        }
      
      
    }
`;

export const TableContainer = styled.div`
width:100%;
margin-left:20px;
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;

  padding:10px 20px 10px 10px;
  // max-height: 500px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color:${props => props.secundary ? Colors.PURPLE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: 16px;
  cursor: pointer;
`;


export const TableHeader = styled.div`
  display:flex;
  flex-direction:row;
  width: 100%;
  height:24px;
  background-color: red;
`;

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.PINK};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.PURPLE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    background-color: ${Colors.GRAY[4]};
`;
export const BorderSwitch = styled.div`  
background: ${Colors.GRAY[6]};
padding-left: 1px;
border-radius: 14px;
width: 57px;
padding-top: 1px;
height: 30px;
display: -webkit-inline-box;
margin-left: 20px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

export const CalendarContainer = styled.div`
z-index: 55;
left: 45px;
position: relative;
`;

export const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;


  &:focus {
    outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: auto;
  white-space: nowrap;
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;

  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
    border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;

  color: #ffffff;

  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  margin-left: 10px;

  text-align: center;
    ${primaryMixin}
`;

